import React, { useCallback } from 'react'
import cn from 'classnames'

import styles from './RadioButton.module.scss'

interface RadioButtonProps<TValue> {
  className?: string
  name: string
  value: TValue
  onChange: (value: TValue) => void
  label: string
  checked: boolean
}
export const RadioButton = <TValue,>({
  className,
  name,
  value,
  onChange,
  label,
  checked,
}: RadioButtonProps<TValue>) => {
  const change = useCallback(() => {
    onChange(value)
  }, [onChange, value])
  return (
    <label
      className={cn(className, styles.container, {
        [styles.isChecked]: checked,
      })}
    >
      <input
        type="radio"
        className={styles.input}
        name={name}
        value={String(value)}
        onChange={change}
        checked={checked}
      />
      <span className={styles.mark}></span>
      <span className={styles.label}>{label}</span>
    </label>
  )
}
